import React from 'react'

export default function CategoryLandingJsonEditorCard({
  title,
  value,
  onChange,
  error,
  minHeight = 180,
  description,
  readOnly = false,
}) {
  return (
    <div className="rounded-xl border p-4 space-y-3 bg-white">
      <div className="font-semibold text-sm">{title}</div>
      {description && (
        <div className="rounded border border-blue-200 bg-blue-50 px-3 py-2 text-xs text-blue-800">
          {description}
        </div>
      )}
      <textarea
        className="w-full rounded border px-3 py-2 font-mono text-xs"
        style={{ minHeight }}
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        readOnly={readOnly}
      />
      {error && <div className="text-xs text-red-600">{error}</div>}
    </div>
  )
}
